<div class="content-all">
    <div class="header">
        <h1 mat-dialog-title>{{'dashboard.reports.title' | translate}}</h1>
        <button mat-icon-button (click)="cancel()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content class="content-dialog" [ngClass]="{'dark': isDark }">
        <div class="custom-vertical-tabs">
            <div class="tab-labels">
                <div *ngFor="let tab of tabLabels; let i = index" class="tab-label"
                    [class.active]="i === activeTabIndex" (click)="selectTab(i)">
                    {{ tab.label | translate: { count: getReportsCount(i) } }}
                </div>
            </div>

            <div class="tab-content">
                <ng-container *ngIf="nestedTabLabels.length > 0; else simpleTabContent">
                    <div class="nested-tab-labels">
                        <div *ngFor="let nestedTab of nestedTabLabels; let j = index" class="nested-tab-label"
                            [class.active]="j === activeNestedTabIndex" (click)="selectNestedTab(j)">
                            {{ nestedTab.label | translate }}
                        </div>
                    </div>

                    <div class="nested-tab-content">
                        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                            <ng-container matColumnDef="dashboard">
                                <th mat-header-cell *matHeaderCellDef class="width-50">{{ 'report.name' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <a [href]="element.url" target="_blank">{{ element.report }}</a>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="createdDate">
                                <th mat-header-cell *matHeaderCellDef class="width-50 date"> Date </th>
                                <td mat-cell *matCellDef="let element" class="date">
                                    {{ formatDate(element.createdDate, tabLabels[activeTabIndex]?.value || 'daily') }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="actions" *ngIf="isAdmin()">
                                <th mat-header-cell *matHeaderCellDef> Actions </th>
                                <td mat-cell *matCellDef="let element;let index=index">

                                    <ng-container>
                                        <button mat-icon-button color="accent" (click)="delete(element)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </ng-container>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </ng-container>

                <ng-template #simpleTabContent>
                    <ng-container *ngIf="dataSource.data.length > 0; else noData">
                        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                            <ng-container matColumnDef="dashboard">
                                <th mat-header-cell *matHeaderCellDef class="width-50">{{ 'report.name' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <a [href]="element.url" target="_blank">{{ element.report }}</a>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="createdDate">
                                <th mat-header-cell *matHeaderCellDef
                                    class="{{isAdmin() ? 'width-50' : 'width-45'}} date"> Date </th>
                                <td mat-cell *matCellDef="let element" class="date">
                                    {{ formatDate(element.createdDate, tabLabels[activeTabIndex]?.value || 'daily') }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="actions" *ngIf="isAdmin()">
                                <th mat-header-cell *matHeaderCellDef class="actions"> Actions </th>
                                <td mat-cell *matCellDef="let element;let index=index" class="actions">

                                    <ng-container>
                                        <button mat-icon-button color="accent" (click)="delete(element)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </ng-container>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </ng-container>

                    <ng-template #noData>
                        <p *ngIf="!loading" class="no-data">{{ 'report.no_report' | translate }}</p>
                        <div *ngIf="loading" class="loading">
                            <mat-spinner diameter="50" class="spinner">
                                <mat-icon class="loading-icon">loop</mat-icon>
                            </mat-spinner>
                        </div>
                    </ng-template>
                </ng-template>
            </div>
        </div>
    </div>